/**
 * Enum that describes the available control types
 */
export enum ControlType {
    checkbox = "checkbox",
    datepicker = "datepicker",
    input = "input",
    radioButton = "radioButton",
    select = "select",
    multiple = "multiple",
    arrayOfControls = "arrayOfControls",
    search = "search",
    matrix = "matrix",
    nvp = "nvp",
    chips = "chips",
    autocomplete = "autocomplete",
    selectAutocomplete = "selectAutocomplete",
    upload = "upload"
}